import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filepdf"
const FilepdfIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.148 15.245V16.649H18.22V18.215H20.88V19.553H18.22V22.114H16.473V15.244z" />
          <path
            fillRule="evenodd"
            d="M12.234 15.245C13.014 15.245 13.672 15.415 14.19 15.743L14.211 15.757Q14.67 16.053 14.975 16.51C15.244 16.915 15.42 17.414 15.491 18Q15.525 18.279 15.527 18.585L15.528 18.63V18.64Q15.528 18.782 15.52 18.919 15.51 19.11 15.488 19.29 15.454 19.57 15.388 19.822L15.382 19.847Q15.242 20.377 14.975 20.791L14.965 20.806Q14.868 20.956 14.756 21.089 14.74 21.104 14.727 21.12 14.622 21.24 14.503 21.347 14.423 21.417 14.34 21.482 14.196 21.592 14.037 21.683 13.782 21.828 13.49 21.925 13.308 21.985 13.113 22.027 12.703 22.113 12.233 22.114H9.444V15.244zM11.19 16.654V20.704H12.005L12.2 20.699 12.203 20.697 12.295 20.686Q12.345 20.68 12.392 20.674 12.445 20.664 12.497 20.652 12.532 20.645 12.565 20.637 12.607 20.626 12.648 20.613 12.695 20.597 12.741 20.58L12.809 20.552 12.885 20.516 12.96 20.475 13.032 20.429 13.094 20.385Q13.126 20.36 13.157 20.333L13.217 20.28 13.277 20.216 13.327 20.158Q13.353 20.125 13.38 20.088L13.425 20.022Q13.448 19.988 13.468 19.95 13.494 19.907 13.517 19.862L13.546 19.794 13.584 19.706Q13.598 19.666 13.61 19.626 13.75 19.213 13.753 18.643V18.633Q13.752 18.528 13.745 18.425L13.74 18.348Q13.733 18.272 13.723 18.198L13.72 18.174Q13.708 18.084 13.69 18C13.505 17.122 12.907 16.654 12.005 16.654zM6.047 15.245 6.122 15.246Q6.35 15.25 6.562 15.283L6.698 15.308Q6.904 15.35 7.093 15.42 7.144 15.44 7.193 15.46 7.63 15.644 7.938 15.964L7.948 15.975Q8.011 16.04 8.068 16.114 8.15 16.219 8.222 16.336C8.447 16.707 8.57 17.16 8.57 17.677V17.687Q8.568 17.876 8.546 18.053 8.476 18.614 8.21 19.039 8.098 19.221 7.951 19.375 7.932 19.395 7.912 19.415 7.864 19.461 7.813 19.506L7.76 19.55Q7.535 19.737 7.255 19.861L7.188 19.89C6.856 20.025 6.473 20.099 6.048 20.099H4.867V22.115H3.118V15.244zM4.867 16.582V18.787H5.626Q5.682 18.787 5.734 18.783H5.743L5.81 18.775 5.87 18.77 5.925 18.762 5.974 18.752Q6.005 18.748 6.037 18.739L6.083 18.725 6.139 18.71 6.175 18.694Q6.283 18.654 6.373 18.594L6.395 18.582Q6.418 18.565 6.439 18.547L6.473 18.52 6.51 18.486 6.535 18.459Q6.673 18.314 6.74 18.107L6.748 18.083 6.765 18.019 6.77 18Q6.802 17.857 6.803 17.686V17.678C6.803 16.963 6.366 16.582 5.628 16.582zM21 8.25V13.745H19.5V9H15.75C14.507 9 13.5 7.993 13.5 6.75V3H4.5V13.745H3V3C3 2.223 3.59 1.585 4.347 1.508L4.5 1.5H14.25zM15 6.75C15 7.164 15.336 7.5 15.75 7.5H18.129L15 4.371z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FilepdfIcon
